import React from 'react';

/** The globe of the Globe Groupe logo, without the wordmark (public/globe_groupe_logo.svg). */
const GlobeMark = ({ className = 'h-6 w-6' }) => (
  <svg viewBox="218 0 315 275" className={className} fill="currentColor" aria-hidden>
    <path d="M492.4 117.6C492.4 53.1 440.1 0.8 375.6 0.8C311.1 0.8 258.8 53.1 258.8 117.6H297.7C297.7 74.6 332.6 39.8 375.6 39.8C418.6 39.8 453.4 74.6 453.4 117.6H297.7C297.7 160.6 332.6 195.4 375.6 195.4C418.6 195.4 453.4 160.5 453.4 117.6H492.4C492.4 182.1 440.1 234.4 375.6 234.4C311.1 234.4 258.8 182.1 258.8 117.6H219.9C219.9 203.6 289.6 273.3 375.6 273.3C461.6 273.3 531.3 203.6 531.3 117.6H492.4Z" />
  </svg>
);

export default GlobeMark;
